import {
  SCORE_RECALCULATION_START,
  SCORE_RECALCULATION_MESSAGE,
  SCORE_RECALCULATION_PROGRESS,
  SCORE_RECALCULATION_DONE,
} from "../../config/actions";

const initialState = {
  messages: [],
  processing: false,
  total: 0,
  completed: 0,
};

const scoreRecalculation = (state = initialState, action) => {
  switch (action.type) {
    case SCORE_RECALCULATION_START:
      return {
        ...state,
        messages: [],
        processing: true,
        completed: 0,
        total: action.payload?.total || 0,
      };

    case SCORE_RECALCULATION_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case SCORE_RECALCULATION_PROGRESS:
      return {
        ...state,
        completed: action.payload.completed,
        total: action.payload.total,
      };

    case SCORE_RECALCULATION_DONE:
      return {
        ...state,
        processing: false,
      };

    default:
      return state;
  }
};

export default scoreRecalculation;
